import { HttpMethod } from "src/constants/http-method";
import { createApiLeverageProductContentUrl, API_DISABLE_LEVERAGE_PRODUCTS_DISCLAMER_URL } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { useRouterLocale } from "src/utils/router/use-router-locale";

export interface ILeverageProductsResponse {
    message: string;
    redirectUrl: string;
}

export function useLeverageProductsQuery(options?: IQueryOptions<ILeverageProductsResponse>) {
    const { language, country } = useRouterLocale();

    return useQuery<ILeverageProductsResponse>({
        url: createApiLeverageProductContentUrl(country, language),
        ...options,
    });
}

interface IRequestDisableLeverageProducts {
    onError: (error: unknown, variables: unknown, context: unknown) => void | Promise<unknown>;
}

export function useDisableLeverageProductsMutation(options?: IRequestDisableLeverageProducts) {
    const { mutate } = useMutation<ILeverageProductsResponse>(API_DISABLE_LEVERAGE_PRODUCTS_DISCLAMER_URL, {
        ...options,
        method: HttpMethod.PUT,
    });
    return () => mutate({});
}
